import React, { useState, useEffect, useContext } from "react";
import { Collapse, Card, CardHeader, CardBody, Button, Badge } from "reactstrap";
import { FaPlus, FaMinus } from "react-icons/fa";
import { MenuContext } from "../MenuSnooze";

const menuSnoozeViewUtil = require("../menuSnoozeUtil");
const constants = require("../../../../utils/domain/constants");
const translator = require("../../../../utils/translator/translator");

function Item(
    {
        item,
        isCategoryItem
    }
) 
{
    const [expanded, setExpanded] = useState(false);
    const [collapseOpen, setCollapseOpen] = useState(false);
    const { handleSnooze, handleItemActivation, selectedMenu, snoozesMap } = useContext(MenuContext);

    useEffect(() =>
    {
        setCollapseOpen(expanded);
    }, [expanded])

    const icon = expanded ? <FaMinus /> : <FaPlus />;
    const handleHeaderClick = (isItemSnoozed) =>
    {
        if (isItemSnoozed)
        {
            setExpanded(false);
        }
        else
        {
            setExpanded(prevState => !prevState);
        }
    }

    const itemHasModifiers = Array.isArray(item.modifierMembers) && item.modifierMembers.length > 0;
    const itemType = isCategoryItem ? constants.SnoozeItemTypes.categoryItem : constants.SnoozeItemTypes.modifierItem;
    const buttonTitle = isCategoryItem ? "item" : "modifier";
    const isItemSnoozed = menuSnoozeViewUtil.isItemSnoozed(selectedMenu.id, snoozesMap, item.id, itemType);
    const snoozeOverview = !expanded && (isCategoryItem ? menuSnoozeViewUtil.getSnoozeOverviewInCategoryItem(selectedMenu, snoozesMap, item) : menuSnoozeViewUtil.getSnoozeOverviewInModifierItem(selectedMenu, snoozesMap, item));
    return (
        <Card className={isItemSnoozed && "snoozed-item"}>
            <CardHeader onClick={() => handleHeaderClick(isItemSnoozed)}>
                <div className="d-flex justify-content-between">
                    <div className="d-flex gap-2 justify-content-start align-items-center gap-1">
                        <div>{itemHasModifiers && icon}</div>
                        <div>{item.caption}</div>
                        <div>
                            {isItemSnoozed &&
                                <h4 className="mb-0">
                                    <Badge className="text-dark item-badge">{translator.getLabel("snoozed")}</Badge>
                                </h4>
                            }
                        </div>
                        {!expanded && snoozeOverview.noOfModifiersSnoozed ?
                            <h4 className="mb-0">
                                <Badge className="text-dark item-badge">
                                    {snoozeOverview.noOfModifiersSnoozed} {translator.getLabel("modifier_snoozed")}
                                </Badge>
                            </h4> :
                            <></>
                        }
                    </div>
                    <div>
                        {isItemSnoozed
                            ? (
                                <Button
                                    color="success"
                                    onClick={(e) =>
                                    {
                                        e.stopPropagation();
                                        handleItemActivation(item, isCategoryItem);
                                    }}
                                >
                                    {translator.getLabel("activate")} {translator.getLabel(buttonTitle)}
                                </Button>
                            )
                            : (
                                <Button
                                    style={{ backgroundColor: "#f0dc74" }}
                                    className="text-dark"
                                    onClick={(e) =>
                                    {
                                        e.stopPropagation();
                                        handleSnooze(item, isCategoryItem)
                                    }}
                                >
                                    {translator.getLabel("snooze")} {translator.getLabel(buttonTitle)}
                                </Button>
                            )
                        }
                    </div>
                </div>
            </CardHeader>
            {
                !isItemSnoozed && expanded && itemHasModifiers && (
                    <Collapse isOpen={collapseOpen}>
                        <CardBody style={{ backgroundColor: buttonTitle === "item" ? '#cce3cc' : '#e7d0c7' }}>
                            {
                                <ModifierMembersContainer modifierMembers={item.modifierMembers} />
                            }
                        </CardBody>
                    </Collapse>
                )
            }
        </Card>
    )
}

function ModifierMembersContainer(
    { modifierMembers }
)
{
    return (
        <div className="d-flex flex-column gap-2">
            {
                modifierMembers.map(modifierMember => <ItemsContainer key={modifierMember.id} modifierMember={modifierMember} />)
            }
        </div>
    )
}

function ItemsContainer(
    { modifierMember }
) 
{
    const { selectedMenu } = useContext(MenuContext);
    const modifierItems = selectedMenu.modifiers.find(modifier => modifier.id === modifierMember.modifierId)?.items || [];
    return (
        modifierItems.map(modItem => <Item key={modItem.id} item={modItem} />)
    )
}


export default Item;